<template>
    <a class="button-remove" @click="$emit('remove')" href="javascript:;">
      	&times;
    </a>
</template>

<script>
export default {
    emits: ['remove'],
};
</script>